export default function AppSection() {
  const scrollTo = (href: string) => {
    const el = document.querySelector(href);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="app" className="w-full py-16 md:py-24 bg-gradient-to-b from-background-100 to-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full flex justify-center lg:justify-start">
            <div className="relative w-[240px] h-[400px] md:w-[280px] md:h-[460px]">
              <div className="absolute inset-0 bg-primary-500/15 rounded-3xl blur-2xl"></div>
              <img
                src="https://readdy.ai/api/search-image?query=A%20smartphone%20displaying%20a%20video%20player%20app%20interface%20with%20Chinese%20movie%20playback%20screen%2C%20progress%20bar%20at%20bottom%2C%20dark%20cinematic%20UI%2C%20warm%20red%20and%20amber%20accent%20colors%2C%20clean%20minimal%20layout%2C%20professional%20app%20design%2C%20isolated%20on%20soft%20warm%20background&width=560&height=920&seq=app-phone-2026-x1&orientation=portrait"
                alt="91影视看片APP下载 - 安卓手机影视APP界面"
                className="relative z-10 w-full h-full object-contain drop-shadow-2xl"
              />
            </div>
          </div>

          <div className="flex-1 w-full text-center lg:text-left">
            <span className="inline-block px-3 py-1 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-4 whitespace-nowrap">
              <i className="ri-smartphone-line mr-1"></i>移动端专属
            </span>
            <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-4">
              91影视看片APP — 掌上影院随心看
            </h2>
            <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-8">
              专为安卓手机优化的<strong>免费影视APP</strong>，安装包体积小巧，适配主流安卓机型。
              看片软件下载后即可畅享<strong>海量高清影视资源</strong>，支持4K超清画质、多线路自动切换、倍速播放与记忆续播等实用功能。
              无论通勤路上还是居家休闲，<strong>手机影视APP</strong>让你随时随地开启沉浸式追剧体验。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-4">
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl border border-background-200">
                <i className="ri-android-line text-accent-600 text-xl w-5 h-5 flex items-center justify-center"></i>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">安卓版本</div>
                  <div className="text-sm font-semibold text-foreground-900">v3.8.2</div>
                </div>
              </div>
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl border border-background-200">
                <i className="ri-hard-drive-2-line text-accent-600 text-xl w-5 h-5 flex items-center justify-center"></i>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">安装包大小</div>
                  <div className="text-sm font-semibold text-foreground-900">28.6 MB</div>
                </div>
              </div>
              <div className="flex items-center gap-2 px-5 py-3 bg-background-50 rounded-xl border border-background-200">
                <i className="ri-shield-check-line text-accent-600 text-xl w-5 h-5 flex items-center justify-center"></i>
                <div className="text-left">
                  <div className="text-xs text-foreground-500">安全检测</div>
                  <div className="text-sm font-semibold text-foreground-900">已通过</div>
                </div>
              </div>
            </div>

            <div className="mt-8 flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#app"
                onClick={(e) => { e.preventDefault(); }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 bg-primary-500 text-white text-base font-semibold rounded-xl hover:bg-primary-600 transition-all cursor-pointer whitespace-nowrap shadow-[0_4px_20px_rgba(200,60,35,0.35)]"
              >
                <i className="ri-download-2-line text-xl"></i>
                安卓下载 APK
              </a>
              <a
                href="#about"
                onClick={(e) => { e.preventDefault(); scrollTo('#about'); }}
                className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-8 py-4 border-2 border-background-300 text-foreground-700 text-base font-semibold rounded-xl hover:border-primary-400 hover:text-primary-600 transition-all cursor-pointer whitespace-nowrap"
              >
                <i className="ri-file-text-line text-xl"></i>
                查看安装教程
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}